import React, { Component } from 'react';

import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Typography, Grid, } from '@material-ui/core';
import { getUserType } from '../../../utils';
import { USER_TYPE } from '../../../constants/comman';
import cx from 'classnames'

const styles = (theme: Theme) => createStyles({
	center: {
		maxWidth: "315px",
		textAlign: "center"
	},
	img: {
		width: "100%"
	},
	button: {
		marginTop: "25px"
	},
	heading: {
		marginTop: "20px"
	},
	emptyScreenBlock: {
		backgroundColor: '#FFFFFF',
		borderRadius: '4px',
		minHeight: 'calc(100vh - 220px)',
	}
});

interface NoFilteredContentProps extends WithStyles<typeof styles> {
	isRestrictedAccess?: boolean
}

interface NoFilteredContentStates {
}

class NoFilteredContent extends Component<NoFilteredContentProps, NoFilteredContentStates> {

	getImageUrl() {
		const baseUrl = '/assets/img/mylibrary/';
		const imageName = this.props.isRestrictedAccess ? 'restricted-access.svg' : 'emptyScreenForNoContent.svg';
		return baseUrl + imageName;
	}

	render() {

		const { classes, isRestrictedAccess } = this.props;
		return (
			<>
				
				<Grid container
					spacing={0}
					direction="column"
					alignItems="center"
					justify="center"
					className={classes.emptyScreenBlock}>
					{isRestrictedAccess ?
						<Grid item className={classes.center}>
							<img alt="restricted access" className={classes.img} src={this.getImageUrl()} />
							<Typography variant="h6" className={classes.heading} gutterBottom>Restricted Access</Typography>
							<Typography variant="caption" color="textSecondary" gutterBottom>Sorry, you don't have access to view this content. </Typography>
							<Typography variant="caption" color="textSecondary" gutterBottom>Please ensure you have the required role. </Typography>
						</Grid>
						: <Grid item className={classes.center}>
							<img alt="no content" className={classes.img} src={this.getImageUrl()} />
							<Typography variant="h6" className={classes.heading} gutterBottom>Oh Snap! We can't find it</Typography>
							<Typography variant="caption" color="textSecondary" gutterBottom>You can always create your own content</Typography>
						</Grid>
					}
				</Grid>
			</>
		)
	}
}

// @ts-ignore
export default withStyles(styles)(NoFilteredContent);
